
import React from 'react';
import Header from '@/components/Header';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts';
import { BarChart3 } from 'lucide-react';

// Mock data for the last 30 days - in real implementation this would come from GA4 API
const calibrationsByType = [
  { type: 'Flow Rate', count: 245 },
  { type: 'Pressure Advance', count: 189 },
  { type: 'Bed Leveling', count: 156 },
  { type: 'Extruder Steps', count: 134 },
  { type: 'Temperature Tower', count: 98 }
];

const chartConfig = {
  count: {
    label: "Calibrations",
    color: "hsl(var(--primary))",
  },
};

const Analytics = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header useBackButton={true} pageName="Analytics Report" />
      
      <div className="container py-8 pt-[64px] space-y-8">
        {/* Page Header */}
        <div>
          <h1 className="text-3xl font-bold mb-2 flex items-center gap-3">
            <BarChart3 className="h-8 w-8" />
            Calibration Analytics
          </h1>
          <p className="text-muted-foreground">
            Calibration completion statistics from the last 30 days
          </p>
        </div>

        {/* Calibrations by Type Chart */}
        <Card>
          <CardHeader>
            <CardTitle>Calibrations by Type</CardTitle>
            <CardDescription>
              Number of completed calibrations by type in the last 30 days
            </CardDescription>
          </CardHeader>
          <CardContent>
            <ChartContainer config={chartConfig} className="h-[400px]">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={calibrationsByType} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                  <XAxis 
                    dataKey="type" 
                    tick={{ fontSize: 12 }}
                    angle={-45}
                    textAnchor="end"
                    height={80}
                  />
                  <YAxis tick={{ fontSize: 12 }} />
                  <ChartTooltip content={<ChartTooltipContent />} />
                  <Bar 
                    dataKey="count" 
                    fill="var(--color-count)"
                    radius={[4, 4, 0, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
            </ChartContainer>
          </CardContent>
        </Card>

        {/* Summary Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Card>
            <CardContent className="p-6">
              <div className="text-2xl font-bold">822</div>
              <p className="text-sm text-muted-foreground">Total Calibrations (30 days)</p>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-6">
              <div className="text-2xl font-bold">27.4</div>
              <p className="text-sm text-muted-foreground">Daily Average</p>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-6">
              <div className="text-2xl font-bold">Flow Rate</div>
              <p className="text-sm text-muted-foreground">Most Popular Type</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
